import React, { useState, useCallback } from 'react';
import Datepicker from 'components/actions/DatePicker';
import AnalyticsSerive from 'api/services/AnalyticsService';
import { tailwindConfig, hexToRGB, getDateRangeString, getI18nValue } from 'utils/Utils';
import LineChart03 from 'charts/LineChart03';
import { ExportCSV } from 'components/ExportCSV';
import Wrapper from 'components/Wrapper';
import { useTranslation } from "react-i18next";
import { useAxios } from 'hooks/useAxios';
import ChannelSelect from './ChannelSelect';
import LanguageSelect from './LanguageSelect';

function ConversationsPerDay() {

    const { t } = useTranslation();

    const [selectedDateRanges, setSelectedDateRanges] = useState(
        {
            startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
            endDate: new Date(),
            key: 'selection',
        }
    );

    const [channel, setChannel] = useState('');
    const [language, setLanguage] = useState('');

    // Stable reference so MemoDatepicker never re-renders (setDateRanges is already
    // stable from useState, but useCallback makes the intent explicit).
    const handleDateChange = useCallback((newRanges) => setSelectedDateRanges(newRanges), []);

    const [data, error, loading] = useAxios(AnalyticsSerive.getConverstationsPerDay(selectedDateRanges, channel, language))


    return (

        <div className='p-4 col-span-full sm:col-span-full xl:col-span-full bg-white shadow-sm rounded-sm border border-gray-200 min-h-[480px] flex flex-col'>
            <div className="sm:flex sm:justify-between sm:items-center border-b border-gray-100 mb-4">
                <div className='mb-4'>
                    <header className='capitalize text-xl font-semibold text-gray-800 '>{t(getI18nValue('analytics.conversations_per_day', "title"))}</header>
                    <p className='text-sm font-light'>{t(getI18nValue('analytics.conversations_per_day', "description"))}</p>
                </div>
                <div className="flex items-center gap-2 flex-wrap mb-6 p-4 bg-white shadow-sm rounded-sm border border-gray-200">
                    <ExportCSV csvData={data} disabled={!data} fileName={`conversations_${getDateRangeString(selectedDateRanges)}`} />
                    <ChannelSelect value={channel} onChange={setChannel} />
                    <LanguageSelect value={language} onChange={setLanguage} />
                    <Datepicker callBack={handleDateChange} />
                </div>
            </div>

            <Wrapper error={error} isLoading={loading} className="flex-1 min-h-0">
                <LineChart03
                    data={{
                        labels: data?.date ? data?.date : [],
                        datasets: [
                            {
                                label: '',
                                data: data?.total_conversation ? data?.total_conversation : [],
                                fill: true,
                                backgroundColor: `rgba(${hexToRGB(tailwindConfig().theme.colors.blue[500])}, 0.08)`,
                                borderColor: tailwindConfig().theme.colors.blue[500],
                                borderWidth: 2,
                                tension: 0.1,
                                pointRadius: 0,
                                pointHoverRadius: 3,
                                pointBackgroundColor: tailwindConfig().theme.colors.blue[500],
                                clip: 20,
                            },
                        ],
                    }} />
            </Wrapper>

        </div >

    );
}


export default ConversationsPerDay;
